/**
 * Created by 叶子 on 2017/7/30.
 */
import { combineReducers } from 'redux';
import * as type from '../action/type';

const handleData = (state = {isFetching: true, data: {}}, action) => {
    switch (action.type) {
        case type.REQUEST_DATA:
            return {...state, isFetching: true};
        case type.RECEIVE_DATA:
            return {...state, isFetching: false, data: action.data};
        default:
            return {...state};
    }
};
const httpData = (state = {}, action) => {
    switch (action.type) {
        case type.RECEIVE_DATA:
        case type.REQUEST_DATA:
            return {
                ...state,
                [action.category]: handleData(state[action.category], action)
            };
        default:
            return {...state};
    }
};

const countAll = (state, action) => {
    switch (action.type) {
        case type.COUNT_All:
            return {...state, data: action.countall,dataList:action.list};
        default:
            return {...state};
    }
};

const countAllMy = (state, action) => {
    switch (action.type) {
        case type.COUNT_All_MY:
            return {...state, data: action.countall,dataList:action.list};
        default:
            return {...state};
    }
};

const orderNo = (state, action) => {
    switch (action.type) {
        case type.ORDER_NO:
            return {...state,orderNo:action.orderNo,flag:action.flag};
        default:
            return {...state};
    }
};
const Visible = (state, action) => {
    switch (action.type) {
        case type.VISIBLE_DATA:
            return {...state,conversationVisible:action.conversationVisible,orderNows:action.orderNows};
        default:
            return {...state};
    }
};

const CountNum = (state, action) => {
    switch (action.type) {
        case type.COUNT_NUMBER:
            return {...state,countNumber:action.countNumber};
        default:
            return {...state};
    }
}

const CountNumMy = (state, action) => {
    switch (action.type) {
        case type.COUNT_NUMBER_MY:
            return {...state,countNumberMy:action.countNumberMy};
        default:
            return {...state};
    }
}

const Flag = (state, action) => {
    switch (action.type) {
        case type.FLAG:
            return {...state,flag:action.flag};
        default:
            return {...state};
    }
}
export default combineReducers({
    httpData,countAll,orderNo,Visible,CountNum,Flag,countAllMy,CountNumMy
});



// WEBPACK FOOTER //
// ./src/reducer/index.js